import Vue from 'vue'
import VueRouter from 'vue-router'
import { store } from '@/store/'

import Login from '@/views/auth/Login.vue'
import Logout from '@/views/auth/Logout.vue'
import SignUp from '@/views/auth/SignUp.vue'
import SendResetPassword from '@/views/auth/SendResetPassword.vue'
import ResetPassword from '@/views/auth/ResetPassword.vue'
import ResetPasswordSent from '@/views/auth/ResetPasswordSent.vue'
import NotFound from '@/qlipmark-shared/views/NotFound.vue'
// import Home from '@/views/Home.vue'
import PreLaunch from '@/views/PreLaunch.vue'
import Landing from '@/views/Landing.vue'
import Privacy from '@/views/PrivacyPolicy.vue'
// users components
import Users from '@/views/Users.vue'
import User from '@/components/users/User.vue'
import UserForm from '@/components/users/UserForm.vue'
/*** rgv imports ***/

// bookmarks components
import BookmarkSuccess from '@/qlipmark-shared/components/bookmarks/BookmarkSuccess.vue'
import Bookmarks from '@/views/Bookmarks.vue'
import BookmarksTable from '@/components/bookmarks/BookmarksListTable.vue'
import Bookmark from '@/components/bookmarks/Bookmark.vue'
import BookmarkForm from '@/components/bookmarks/BookmarkForm.vue'

// Tags
import Tags from '@/views/Tags.vue'

import ImportBookmarks from '@/views/ImportBookmarks.vue'
import Export from '@/views/Export.vue'
import Info from '@/views/Info.vue'


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter)

const publicRoutes = [
  "PreLaunch",
  "Landing",
  "Privacy",
  "Login",
  "SignUp",
  "SendResetPassword",
  "ResetPassword",
  "ResetPasswordSent",
  "NotFound"
]

const routes = [
  { name: 'PreLaunch', path: '/', component: PreLaunch, meta: { layout: "landing" } },
  { name: 'Landing',
    path: '/landing',
    component: Landing,
    meta: {
      layout: "landing",
      title: 'Qlipmark - A Bookmarking Tool',
      metaTags: [
        {
          name: 'description',
          content: 'The home page of our example app.'
        },
        {
          property: 'og:description',
          content: 'The home page of our example app.'
        }
      ]
    }
  },
  { name: 'Privacy', path: '/privacy', component: Privacy, meta: { layout: "landing" } },
  // { name: 'Home', path: '/home', component: Home },
  { name: 'Login', path: '/login', component: Login, meta: { layout: "auth" }, props: true },
  { name: 'Logout', path: '/logout', component: Logout, meta: { layout: "auth" } },
  { name: 'SignUp', path: '/signup', component: SignUp, meta: { layout: "auth" } },
  { name: 'SendResetPassword', path: '/recover_password', component: SendResetPassword, meta: { layout: "auth" } },
  { name: 'ResetPassword', path: '/new_password', component: ResetPassword, meta: { layout: "auth" }, props: (route) => ({ resetPasswordToken: route.query.token }) },
  { name: 'ResetPasswordSent', path: '/recover/sent', component: ResetPasswordSent, meta: { layout: "auth" }, props: true },
  { name: 'NotFound', path: '/404', component: NotFound, meta: { layout: "auth" } },
  // users paths
  { name: 'UserList', path: '/users(/page/:page)?', component: Users, props: true },
  { name: 'UserNew', path: '/users/new', component: UserForm },
  { name: 'UserShow', path: '/users/:id', component: User, props: true },
  { name: 'UserEdit', path: '/users/:id/edit', component: UserForm, props: true },
  /*** rgv routes ***/
  // bookmarks paths
  // { name: 'BookmarkList', path: '/bookmarks', component: Bookmarks },
  // { path: '/bookmarks', redirect: { name: 'BookmarkListPaged', params: {page: 1} }},
  // { name: 'Home', path: '/home', component: Bookmarks },
  { name: 'Home', path: '/home', redirect: { name: 'BookmarkList' }},
  // { name: 'BookmarkListPaged', path: '/bookmarks/page/:page', component: Bookmarks, props: true },
  // { name: 'BookmarkListFiltered', path: '/bookmarks/p(age)?/:page/f/:selectedTagsParams*', component: Bookmarks, props: true },
  { name: 'BookmarkList', path: '/bookmarks', component: Bookmarks, props: true },
  { name: 'BookmarkListFiltered', path: '/bookmarks/f/:selectedTagsParams*', component: Bookmarks, props: true },
  { name: 'BookmarkListTable', path: '/bookmarks/table(/page/:page)?', component: BookmarksTable, props: true },
  { name: 'BookmarkNew', path: '/bookmarks/new', component: BookmarkForm, meta: { layout: "nosidebar" } },
  { name: 'BookmarkSuccess', path: '/bookmark/success', component: BookmarkSuccess, meta: { layout: "auth" } },
  { name: 'BookmarkShow', path: '/bookmarks/:id', component: Bookmark, props: true },
  { name: 'BookmarkEdit', path: '/bookmarks/:id/edit', component: BookmarkForm, props: true },

  { name: 'EditTags', path: '/tags', component: Tags, props: true },
  { name: 'EditTag', path: '/tags/:tag', component: Tags, props: true },

  { name: 'ImportBookmarks', path: '/import', component: ImportBookmarks },
  { name: 'Export', path: '/export', component: Export },
  { name: 'Info', path: '/info', component: Info },

  { path: '*', component: NotFound, meta: { layout: "auth" } },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  const isPrivate = !publicRoutes.includes(to.name)
  const isAuthenticated = store.getters['auth/logged'];
  if (isPrivate && !isAuthenticated) {
    next({path: '/login'})
  } else {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if(!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '');

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

    next();
  }
});

export default router
